(() => {
  if (window.FoldingLinkAppDownloads) return;

  const SHOPIFY_FORM_POLL_INTERVAL = 60;
  const SHOPIFY_FORM_TIMEOUT = 15000;
  const SHOPIFY_FORM_POPOVER_RESERVE = 176;
  const SHOPIFY_FORM_STYLE_ATTRIBUTE = 'data-foldinglink-shopify-form-style';

  const shopifyFormPresentationCss = `
    :host {
      width: 100%;
    }

    [data-foldinglink-form-viewport],
    section[role="dialog"] {
      overflow: visible !important;
    }

    [data-foldinglink-form-root]:has([data-foldinglink-form-select-trigger][aria-expanded="true"]) {
      box-sizing: content-box !important;
      padding-bottom: var(--foldinglink-shopify-form-overflow-height, 0px) !important;
    }

    section[role="dialog"] {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    [data-foldinglink-app-header] {
      display: none !important;
    }

    form {
      display: grid !important;
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: none !important;
      padding: 0 !important;
      gap: var(--foldinglink-space-form-field-gap, 16px) !important;
    }

    [data-foldinglink-form-proxy] {
      position: absolute !important;
      overflow: hidden !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      border: 0 !important;
      clip: rect(0 0 0 0) !important;
    }

    [data-foldinglink-form-field],
    [data-foldinglink-form-select] {
      display: grid !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      gap: var(--foldinglink-space-form-label-control, 8px) !important;
    }

    [data-foldinglink-form-field] > label,
    [data-foldinglink-form-select-label] {
      position: static !important;
      inset: auto !important;
      order: -1 !important;
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
      color: var(--foldinglink-color-text-primary, #2a2e31) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: var(--foldinglink-type-label, 14px) !important;
      font-weight: var(--foldinglink-weight-label, 600) !important;
      line-height: 1.5 !important;
      text-align: left !important;
      transform: none !important;
    }

    [data-foldinglink-form-field] > input,
    [data-foldinglink-form-select-trigger] {
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: var(--foldinglink-app-form-control-height, 52px) !important;
      border-radius: var(--input-radius, var(--foldinglink-app-form-control-radius, 999px)) !important;
      background: rgb(var(--color-layer, 255 255 255)) !important;
      box-shadow: none !important;
      color: var(--foldinglink-color-text-primary, #2a2e31) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: var(--foldinglink-type-body, 16px) !important;
      font-weight: var(--foldinglink-weight-body, 500) !important;
    }

    [data-foldinglink-form-field] > input {
      height: calc(var(--foldinglink-app-form-control-height, 52px) + 1.333333px) !important;
      min-height: calc(var(--foldinglink-app-form-control-height, 52px) + 1.333333px) !important;
      padding: 0 calc(var(--foldinglink-app-form-control-padding-inline, 20px) + 2px) !important;
      border: 1px solid rgba(var(--color-border, 229, 229, 229), .4) !important;
      line-height: calc(1 + .4 / var(--font-body-scale, 1)) !important;
      letter-spacing: calc(var(--font-body-scale, 1) * -.016rem) !important;
    }

    [data-foldinglink-form-field] > input::placeholder {
      color: var(--foldinglink-color-text-primary, #2a2e31) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1) * 1.6rem) !important;
      font-weight: 500 !important;
      line-height: calc(1 + .4 / var(--font-body-scale, 1)) !important;
      letter-spacing: calc(var(--font-body-scale, 1) * -.016rem) !important;
      opacity: .65 !important;
    }

    [data-foldinglink-form-field] > input:focus,
    [data-foldinglink-form-select-trigger]:focus-visible,
    [data-foldinglink-form-select-trigger][aria-expanded="true"] {
      outline: 2px solid color-mix(in srgb, var(--foldinglink-color-accent, #1677ff) 22%, transparent) !important;
      outline-offset: 1px !important;
      border-color: var(--foldinglink-color-accent, #1677ff) !important;
      box-shadow: none !important;
    }

    [data-foldinglink-form-field] > input[aria-invalid="true"] {
      border-color: var(--form-error-color, #e02229) !important;
      outline: 2px solid color-mix(in srgb, var(--form-error-color, #e02229) 18%, transparent) !important;
      outline-offset: 1px !important;
    }

    [data-foldinglink-form-submit],
    button[type="submit"] {
      position: relative !important;
      justify-self: center !important;
      align-self: center !important;
      box-sizing: border-box !important;
      width: max-content !important;
      max-width: 100% !important;
      min-width: 0 !important;
      min-height: 60px !important;
      margin-top: max(0px, calc(var(--foldinglink-space-form-submit-gap, 24px) - var(--foldinglink-space-form-field-gap, 16px))) !important;
      padding: 21px calc(42px + var(--buttons-scale, 1) * 24px) !important;
      border: 1px solid rgba(255, 255, 255, .54) !important;
      border-radius: var(--foldinglink-app-form-control-radius, 999px) !important;
      background:
        linear-gradient(180deg, rgba(255, 255, 255, .35) 0 14%, transparent 30%),
        linear-gradient(135deg, color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 92%, white), color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 86%, black)) !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .72), inset 0 -1px 0 color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 58%, transparent), 0 10px 24px color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 24%, transparent) !important;
      color: transparent !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1) * 1.8rem) !important;
      font-weight: 500 !important;
      line-height: calc(1 + .44 / var(--font-body-scale, 1)) !important;
      text-align: center !important;
      white-space: nowrap !important;
      transform: none !important;
      isolation: isolate !important;
      overflow: hidden !important;
      transition:
        border-color .3s ease,
        box-shadow .3s ease !important;
    }

    [data-foldinglink-form-submit]::before,
    button[type="submit"]::before {
      content: "" !important;
      position: absolute !important;
      z-index: 0 !important;
      top: 100% !important;
      left: 50% !important;
      width: 150% !important;
      height: 330% !important;
      border-radius: 50% 50% 0 0 !important;
      background: rgb(var(--color-secondary-button, 255, 255, 255)) !important;
      transform: translateX(-50%) !important;
      transition:
        top .5s cubic-bezier(.25, .74, .22, .99) .05s,
        width .5s cubic-bezier(.25, .74, .22, .99) .05s,
        height .5s cubic-bezier(.25, .74, .22, .99) .05s,
        border-radius .5s cubic-bezier(.25, .74, .22, .99) .22s !important;
    }

    [data-foldinglink-form-submit]::after,
    button[type="submit"]::after {
      content: attr(data-foldinglink-form-submit-label) !important;
      position: absolute !important;
      z-index: 1 !important;
      inset: 0 !important;
      display: grid !important;
      place-items: center !important;
      color: transparent !important;
      font: inherit !important;
      line-height: inherit !important;
      text-align: center !important;
      text-shadow:
        0 0 0 var(--foldinglink-color-inverse, #fff),
        0 3rem 0 transparent !important;
      transition: text-shadow .3s ease !important;
      pointer-events: none !important;
    }

    [data-foldinglink-form-submit]:not(:disabled):hover::before,
    button[type="submit"]:not(:disabled):hover::before {
      top: 0 !important;
      width: 101% !important;
      height: 101% !important;
      border-radius: 0 !important;
    }

    [data-foldinglink-form-submit]:not(:disabled):hover,
    button[type="submit"]:not(:disabled):hover {
      border-color: rgb(var(--color-button, 1, 138, 202)) !important;
      transform: none !important;
    }

    [data-foldinglink-form-submit]:not(:disabled):hover::after,
    button[type="submit"]:not(:disabled):hover::after {
      text-shadow:
        0 -3rem 0 transparent,
        0 0 0 rgb(var(--color-button, 1, 138, 202)) !important;
    }

    [data-foldinglink-form-select-trigger] {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: var(--foldinglink-space-secondary-action, 12px) !important;
      padding: 0 var(--foldinglink-app-form-control-padding-inline, 20px) !important;
      border: 1px solid color-mix(in srgb, var(--foldinglink-color-text-muted, #8a94a3) 24%, transparent) !important;
      border-radius: var(--foldinglink-app-form-control-radius, 999px) !important;
      line-height: calc(1 + .42 / var(--font-body-scale, 1)) !important;
      cursor: pointer !important;
    }

    [data-foldinglink-form-select-value] {
      display: block !important;
      flex: 0 1 auto !important;
      align-self: center !important;
      width: auto !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 0 !important;
      color: var(--foldinglink-color-text-primary, #2a2e31) !important;
      font-size: calc(var(--font-body-scale, 1) * 1.5rem) !important;
      font-weight: 500 !important;
      line-height: calc(1 + .42 / var(--font-body-scale, 1)) !important;
      text-transform: none !important;
      opacity: .6 !important;
    }

    [data-foldinglink-form-select-value]:empty::before {
      content: attr(data-foldinglink-form-placeholder) !important;
    }

    [data-foldinglink-form-select-trigger][data-foldinglink-form-has-value] [data-foldinglink-form-select-value] {
      opacity: 1 !important;
    }

    [data-foldinglink-form-select-icon] {
      display: block !important;
      position: static !important;
      inset: auto !important;
      flex: 0 0 auto !important;
      width: 20px !important;
      height: 20px !important;
      margin: 0 !important;
      padding: 0 !important;
      background: var(--foldinglink-color-text-primary, #2a2e31) !important;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M5.67665 8.19406C5.4214 7.92606 5.01684 7.93668 4.77499 8.22171C4.53252 8.50605 4.54335 8.95483 4.79925 9.22428L10.8613 15.6054C10.9838 15.7344 11.1427 15.7997 11.3003 15.7997C11.4579 15.7997 11.6162 15.7344 11.7387 15.6054L17.8007 9.22428C18.0566 8.95486 18.0675 8.50605 17.825 8.22174C17.5825 7.93671 17.1786 7.92537 16.9234 8.19409L11.3003 14.1136L5.67665 8.19406Z'/%3E%3C/svg%3E") center / contain no-repeat !important;
      transition: transform 180ms ease !important;
    }

    [data-foldinglink-form-select-icon] svg {
      display: none !important;
    }

    [data-foldinglink-form-select-trigger][aria-expanded="true"] [data-foldinglink-form-select-icon] {
      transform: rotate(180deg) !important;
    }

    [data-foldinglink-form-select] > div:has(> [role="listbox"]),
    [data-foldinglink-form-popover] {
      inset: calc(100% + 16px) 0 auto !important;
      margin: 0 !important;
      border: 0 !important;
      border-radius: var(--foldinglink-app-form-popover-radius, 16px) !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: visible !important;
      transition: none !important;
    }

    [data-foldinglink-form-listbox],
    [role="listbox"] {
      box-sizing: border-box !important;
      max-height: min(320px, 45vh) !important;
      padding: 6px !important;
      border: 1px solid color-mix(in srgb, var(--foldinglink-color-text-muted, #8a94a3) 24%, transparent) !important;
      border-radius: var(--foldinglink-app-form-popover-radius, 16px) !important;
      background: color-mix(in srgb, rgb(var(--color-layer, 255 255 255)) 92%, transparent) !important;
      box-shadow: 0 18px 50px color-mix(in srgb, var(--foldinglink-color-text-primary, #2a2e31) 18%, transparent) !important;
      backdrop-filter: blur(18px) !important;
      overflow-y: auto !important;
    }

    [data-foldinglink-form-option],
    [role="option"] {
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: 44px !important;
      padding: 10px 14px !important;
      border: 0 !important;
      border-radius: var(--foldinglink-app-form-option-radius, 10px) !important;
      background: transparent !important;
      box-shadow: none !important;
      color: var(--foldinglink-color-text-primary, #2a2e31) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: var(--foldinglink-type-label, 14px) !important;
      line-height: 1.5 !important;
      text-align: left !important;
      outline: 0 !important;
      cursor: pointer !important;
    }

    [data-foldinglink-form-option-row] {
      border: 0 !important;
      border-radius: var(--foldinglink-app-form-option-radius, 10px) !important;
      background: transparent !important;
      box-shadow: none !important;
      outline: 0 !important;
    }

    [data-foldinglink-form-option]:hover,
    [data-foldinglink-form-option][aria-selected="true"],
    [role="option"]:hover,
    [role="option"][aria-selected="true"] {
      border: 0 !important;
      background: color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 18%, rgb(var(--color-layer, 255 255 255))) !important;
      box-shadow: none !important;
      outline: 0 !important;
    }

    [data-foldinglink-form-option]:focus-visible,
    [role="option"]:focus-visible {
      background: color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 18%, rgb(var(--color-layer, 255 255 255))) !important;
      outline: 0 !important;
    }

    [data-foldinglink-form-select][data-foldinglink-keyboard-open] [data-foldinglink-form-option]:focus-visible,
    [data-foldinglink-form-select][data-foldinglink-keyboard-open] [role="option"]:focus-visible {
      background: color-mix(in srgb, var(--foldinglink-color-accent, #156cf9) 18%, rgb(var(--color-layer, 255 255 255))) !important;
      outline: 0 !important;
    }

    [data-foldinglink-form-disclaimer] {
      color: var(--foldinglink-color-text-secondary, #5f6875) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: var(--foldinglink-type-caption, 12px) !important;
      line-height: 1.45 !important;
      text-align: center !important;
    }

    @media (max-width: 749px) {
      [data-foldinglink-form-field] > input,
      [data-foldinglink-form-select-trigger] {
        min-height: var(--foldinglink-app-form-control-height, 44px) !important;
        font-size: var(--foldinglink-type-label, 14px) !important;
      }

      [data-foldinglink-form-field] > input {
        height: calc(var(--foldinglink-app-form-control-height, 44px) + 1.333333px) !important;
        min-height: calc(var(--foldinglink-app-form-control-height, 44px) + 1.333333px) !important;
        padding-inline: calc(var(--foldinglink-app-form-control-padding-inline, 14px) + 2px) !important;
      }

      [data-foldinglink-form-select-trigger] {
        padding-inline: var(--foldinglink-app-form-control-padding-inline, 14px) !important;
      }

      [data-foldinglink-form-submit],
      button[type="submit"] {
        min-height: 48px !important;
        padding: 17px calc(clamp(18px, 6vw, 28px) + var(--buttons-scale, 1) * 20px + 7.5px) !important;
        font-size: calc(var(--font-body-scale, 1) * 1.6rem) !important;
        line-height: calc(1 + .4 / var(--font-body-scale, 1)) !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      [data-foldinglink-form-submit],
      button[type="submit"],
      [data-foldinglink-form-submit]::before,
      button[type="submit"]::before,
      [data-foldinglink-form-submit]::after,
      button[type="submit"]::after,
      [data-foldinglink-form-select-icon] {
        transition: none !important;
      }
    }
  `;

  const initFormSelect = (root) => {
    if (root.dataset.foldinglinkFormSelectInit === 'true') return;

    const nativeSelect = root.querySelector('[data-foldinglink-form-select-native]');
    const enhanced = root.querySelector('[data-foldinglink-form-select-enhanced]');
    const trigger = root.querySelector('[data-foldinglink-form-select-trigger]');
    const valueNode = root.querySelector('[data-foldinglink-form-select-value]');
    const popover = root.querySelector('xo-popover');
    const optionButtons = Array.from(root.querySelectorAll('[data-foldinglink-form-select-option]'));
    if (!nativeSelect || !enhanced || !trigger || !valueNode || !popover || !optionButtons.length) return;

    root.dataset.foldinglinkFormSelectInit = 'true';
    root.classList.add('is-enhanced');
    enhanced.hidden = false;

    const abortController = new AbortController();
    const eventOptions = { signal: abortController.signal };

    const syncSelection = () => {
      const selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
      const selectedValue = nativeSelect.value;
      valueNode.textContent = selectedOption?.textContent || nativeSelect.options[0]?.textContent || '';
      optionButtons.forEach((button) => {
        button.setAttribute('aria-selected', String(button.dataset.value === selectedValue));
      });
      if (selectedValue) {
        root.classList.remove('is-invalid');
        trigger.removeAttribute('aria-invalid');
      }
    };

    const closePopover = () => {
      if (popover.hasAttribute('xo-active') && popover.getAttribute('xo-active') !== 'false') {
        trigger.click();
      }
    };

    const selectValue = (value) => {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      closePopover();
      trigger.focus({ preventScroll: true });
    };

    const focusOption = (index) => {
      optionButtons[Math.max(0, Math.min(optionButtons.length - 1, index))]?.focus();
    };

    optionButtons.forEach((button, index) => {
      button.addEventListener('click', () => selectValue(button.dataset.value || ''), eventOptions);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          focusOption((index + 1) % optionButtons.length);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          focusOption((index - 1 + optionButtons.length) % optionButtons.length);
        } else if (event.key === 'Home') {
          event.preventDefault();
          focusOption(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          focusOption(optionButtons.length - 1);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closePopover();
          trigger.focus({ preventScroll: true });
        }
      }, eventOptions);
    });

    trigger.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      const isOpen = popover.hasAttribute('xo-active') && popover.getAttribute('xo-active') !== 'false';
      if (!isOpen) trigger.click();
      requestAnimationFrame(() => {
        const selectedIndex = optionButtons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
        focusOption(selectedIndex >= 0 ? selectedIndex : (event.key === 'ArrowUp' ? optionButtons.length - 1 : 0));
      });
    }, eventOptions);

    nativeSelect.addEventListener('change', syncSelection, eventOptions);
    nativeSelect.addEventListener('invalid', (event) => {
      event.preventDefault();
      root.classList.add('is-invalid');
      trigger.setAttribute('aria-invalid', 'true');
      trigger.focus({ preventScroll: false });
    }, eventOptions);

    const form = nativeSelect.form;
    form?.addEventListener('reset', () => requestAnimationFrame(syncSelection), eventOptions);

    const popoverObserver = new MutationObserver(() => {
      const expanded = popover.hasAttribute('xo-active') && popover.getAttribute('xo-active') !== 'false';
      trigger.setAttribute('aria-expanded', String(expanded));
    });
    popoverObserver.observe(popover, { attributes: true, attributeFilter: ['xo-active'] });

    root.foldinglinkDestroyFormSelect = () => {
      abortController.abort();
      popoverObserver.disconnect();
      delete root.dataset.foldinglinkFormSelectInit;
      delete root.foldinglinkDestroyFormSelect;
    };

    syncSelection();
  };

  const findControlLabel = (shadowRoot, control) => {
    const labelledBy = (control.getAttribute('aria-labelledby') || '').trim().split(/\s+/).filter(Boolean);
    for (const id of labelledBy) {
      const node = shadowRoot.getElementById(id);
      if (node?.matches('label')) return node;
    }

    if (control.id) {
      return Array.from(shadowRoot.querySelectorAll('label')).find((label) => label.htmlFor === control.id) || null;
    }

    return null;
  };

  const setText = (node, value) => {
    const nextValue = (value || '').trim();
    if (node && nextValue && node.textContent.trim() !== nextValue) node.textContent = nextValue;
  };

  const markInputField = (shadowRoot, form, input, labelText, placeholder) => {
    if (!input) return;

    const field = Array.from(form.children).find((child) => child.contains(input)) || input.parentElement;
    const label = findControlLabel(shadowRoot, input) || field?.querySelector('label');
    field?.setAttribute('data-foldinglink-form-field', '');
    setText(label, labelText);
    if (placeholder) input.setAttribute('placeholder', placeholder);
  };

  const scheduleShopifyFormReveal = (root) => {
    if (root.dataset.foldinglinkShopifyFormRevealScheduled === 'true' || root.classList.contains('is-ready')) return;

    root.dataset.foldinglinkShopifyFormRevealScheduled = 'true';
    root.foldinglinkShopifyFormRevealFrame = requestAnimationFrame(() => {
      root.foldinglinkShopifyFormRevealFrame = requestAnimationFrame(() => {
        if (!root.isConnected || root.dataset.foldinglinkShopifyFormInit !== 'true') return;
        root.classList.remove('is-loading', 'is-timeout');
        root.classList.add('is-ready');
        delete root.dataset.foldinglinkShopifyFormRevealScheduled;
        delete root.foldinglinkShopifyFormRevealFrame;
      });
    });
  };

  const syncShopifyFormPopoverOverflow = (root, embed, selectTrigger, listbox) => {
    const isOpen = selectTrigger?.getAttribute('aria-expanded') === 'true' && Boolean(listbox);
    if (!isOpen) {
      root.classList.remove('is-select-open');
      root.style.removeProperty('--foldinglink-shopify-form-base-height');
      root.style.removeProperty('--foldinglink-shopify-form-overflow-height');
      return;
    }

    if (root.classList.contains('is-select-open')) return;

    const embedRect = embed.getBoundingClientRect();
    const listboxRect = listbox.getBoundingClientRect();
    const overflowHeight = Math.max(0, Math.ceil(listboxRect.bottom - embedRect.bottom));
    root.style.setProperty('--foldinglink-shopify-form-base-height', `${embedRect.height}px`);
    root.style.setProperty('--foldinglink-shopify-form-overflow-height', `${overflowHeight}px`);
    root.classList.add('is-select-open');
  };

  const reserveShopifyFormPopoverSpace = (root, embed) => {
    if (root.classList.contains('is-select-open')) return;

    const embedHeight = embed.getBoundingClientRect().height;
    if (embedHeight <= 0) return;

    root.style.setProperty('--foldinglink-shopify-form-base-height', `${embedHeight}px`);
    root.style.setProperty('--foldinglink-shopify-form-overflow-height', `${SHOPIFY_FORM_POPOVER_RESERVE}px`);
    root.classList.add('is-select-open');
  };

  const applyShopifyFormPresentation = (root, embed) => {
    const shadowRoot = embed.shadowRoot;
    const form = shadowRoot?.querySelector('form');
    const dialog = shadowRoot?.querySelector('section[role="dialog"]');
    if (!shadowRoot || !form || !dialog) return false;

    dialog.parentElement?.setAttribute('data-foldinglink-form-viewport', '');
    let shadowContentRoot = dialog;
    while (shadowContentRoot.parentElement) shadowContentRoot = shadowContentRoot.parentElement;
    shadowContentRoot.setAttribute('data-foldinglink-form-root', '');

    let style = shadowRoot.querySelector(`style[${SHOPIFY_FORM_STYLE_ATTRIBUTE}]`);
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(SHOPIFY_FORM_STYLE_ATTRIBUTE, '');
      style.textContent = shopifyFormPresentationCss;
      shadowRoot.append(style);
    }

    const appHeading = dialog.querySelector('h2');
    const appHeader = appHeading?.closest('section');
    if (appHeader) {
      if (root.dataset.hideAppHeader === 'true') appHeader.setAttribute('data-foldinglink-app-header', '');
      else appHeader.removeAttribute('data-foldinglink-app-header');
    }

    const emailInput = shadowRoot.getElementById('email') || form.querySelector('input[type="email"]');
    const nameInput = shadowRoot.getElementById('custom#full_name')
      || Array.from(form.querySelectorAll('input')).find((input) => input.id.includes('full_name'));
    form.querySelector('shop-lead-capture')?.parentElement?.setAttribute('data-foldinglink-form-proxy', '');
    markInputField(shadowRoot, form, emailInput, root.dataset.emailLabel, root.dataset.emailPlaceholder);
    markInputField(shadowRoot, form, nameInput, root.dataset.nameLabel, root.dataset.namePlaceholder);

    const selectLabel = form.querySelector('p[id$="-selector-label"]');
    const selectTrigger = selectLabel
      ? Array.from(form.querySelectorAll('button[aria-labelledby]')).find((button) => {
        return button.getAttribute('aria-labelledby').split(/\s+/).includes(selectLabel.id);
      })
      : form.querySelector('button[aria-labelledby$="-selector-value"]');
    const selectField = selectTrigger
      ? Array.from(form.children).find((child) => child.contains(selectTrigger)) || selectTrigger.parentElement
      : null;

    if (selectField) selectField.setAttribute('data-foldinglink-form-select', '');
    if (selectLabel) {
      selectLabel.setAttribute('data-foldinglink-form-select-label', '');
      setText(selectLabel, root.dataset.platformLabel);
    }
    if (selectTrigger) {
      selectTrigger.setAttribute('data-foldinglink-form-select-trigger', '');
      const valueId = (selectTrigger.getAttribute('aria-labelledby') || '').split(/\s+/).find((id) => id.endsWith('-selector-value'));
      const valueNode = valueId ? shadowRoot.getElementById(valueId) : null;
      const platformPlaceholder = (root.dataset.platformPlaceholder || '').trim();
      const selectedValue = (valueNode?.textContent || '').trim();
      if (valueNode) {
        valueNode.setAttribute('data-foldinglink-form-select-value', '');
        valueNode.setAttribute('data-foldinglink-form-placeholder', platformPlaceholder);
      }
      const hasSelectedValue = Boolean(selectedValue)
        && selectedValue.toLocaleLowerCase() !== platformPlaceholder.toLocaleLowerCase();
      selectTrigger.toggleAttribute('data-foldinglink-form-has-value', hasSelectedValue);
      selectTrigger.querySelector('svg')?.parentElement?.setAttribute('data-foldinglink-form-select-icon', '');

      if (!selectTrigger.hasAttribute('data-foldinglink-form-preopen-bound')) {
        const reserveBeforeOpen = () => {
          if (selectTrigger.getAttribute('aria-expanded') !== 'true') reserveShopifyFormPopoverSpace(root, embed);
        };
        selectTrigger.addEventListener('pointerdown', () => {
          selectField?.removeAttribute('data-foldinglink-keyboard-open');
          reserveBeforeOpen();
        }, { capture: true });
        selectTrigger.addEventListener('keydown', (event) => {
          if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
            selectField?.setAttribute('data-foldinglink-keyboard-open', '');
            reserveBeforeOpen();
          }
        }, { capture: true });
        selectTrigger.setAttribute('data-foldinglink-form-preopen-bound', '');
      }
    }

    const listboxes = Array.from(shadowRoot.querySelectorAll('[role="listbox"]'));
    listboxes.forEach((listbox) => {
      listbox.setAttribute('data-foldinglink-form-listbox', '');
      listbox.parentElement?.setAttribute('data-foldinglink-form-popover', '');
    });
    shadowRoot.querySelectorAll('[role="option"]').forEach((option) => {
      option.setAttribute('data-foldinglink-form-option', '');
      option.parentElement?.setAttribute('data-foldinglink-form-option-row', '');
    });

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      const submitLabel = submitButton.textContent.trim() || root.dataset.submitText || 'Submit';
      submitButton.setAttribute('data-foldinglink-form-submit', '');
      submitButton.setAttribute('data-foldinglink-form-submit-label', submitLabel);
      submitButton.setAttribute('aria-label', submitLabel);
    }

    const disclaimer = form.nextElementSibling;
    disclaimer?.setAttribute('data-foldinglink-form-disclaimer', '');

    syncShopifyFormPopoverOverflow(root, embed, selectTrigger, listboxes[0]);
    scheduleShopifyFormReveal(root);
    return true;
  };

  const initShopifyForm = (root) => {
    if (root.dataset.foldinglinkShopifyFormInit === 'true') return;

    root.dataset.foldinglinkShopifyFormInit = 'true';
    root.classList.add('is-loading');

    const startedAt = performance.now();
    let pollTimer = 0;
    let shadowObserver = null;
    let syncFrame = 0;

    const sync = () => {
      const embed = root.querySelector('shopify-forms-embed');
      if (!embed || !applyShopifyFormPresentation(root, embed)) return false;

      if (!shadowObserver) {
        shadowObserver = new MutationObserver(() => {
          if (syncFrame) return;
          syncFrame = requestAnimationFrame(() => {
            syncFrame = 0;
            applyShopifyFormPresentation(root, embed);
          });
        });
        shadowObserver.observe(embed.shadowRoot, { childList: true, characterData: true, subtree: true });
      }
      return true;
    };

    const poll = () => {
      if (sync()) return;
      if (performance.now() - startedAt >= SHOPIFY_FORM_TIMEOUT) {
        root.classList.remove('is-loading');
        root.classList.add('is-timeout');
        return;
      }
      pollTimer = window.setTimeout(poll, SHOPIFY_FORM_POLL_INTERVAL);
    };

    root.foldinglinkDestroyShopifyForm = () => {
      window.clearTimeout(pollTimer);
      if (syncFrame) cancelAnimationFrame(syncFrame);
      if (root.foldinglinkShopifyFormRevealFrame) cancelAnimationFrame(root.foldinglinkShopifyFormRevealFrame);
      shadowObserver?.disconnect();
      root.classList.remove('is-loading', 'is-ready', 'is-timeout', 'is-select-open');
      root.style.removeProperty('--foldinglink-shopify-form-base-height');
      root.style.removeProperty('--foldinglink-shopify-form-overflow-height');
      delete root.dataset.foldinglinkShopifyFormRevealScheduled;
      delete root.foldinglinkShopifyFormRevealFrame;
      delete root.dataset.foldinglinkShopifyFormInit;
      delete root.foldinglinkDestroyShopifyForm;
    };

    poll();
  };

  const collectRoots = (scope, selector) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
    roots.push(...scope.querySelectorAll(selector));
    return roots;
  };

  const init = (scope = document) => {
    collectRoots(scope, '[data-foldinglink-form-select]').forEach(initFormSelect);
    collectRoots(scope, '[data-foldinglink-shopify-form]').forEach(initShopifyForm);
  };

  window.FoldingLinkAppDownloads = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    collectRoots(event.target, '[data-foldinglink-form-select]').forEach((root) => root.foldinglinkDestroyFormSelect?.());
    collectRoots(event.target, '[data-foldinglink-shopify-form]').forEach((root) => root.foldinglinkDestroyShopifyForm?.());
  });
})();
